<template>
    <li @click="select()" :class="(active) ? 'active' : ''">
        <span class="badge me-2 bg-dark" v-if="shortTerm !== ''">{{ shortTerm }}</span> {{ longTerm }}
    </li>
  </template>

  
<script>

export default {
    name: "menuItem",
    emits: ['select'],
    data() {
        return {
        }
    },

    props: {
        
        shortTerm: {
            type:String,
            default:''
        },
        longTerm: {
            type:String,
            default:''
        },
        componentId: {
            type:String,
            default:''
        },
        active: {
            type:Boolean,
            default: false
        },
            
    },
    methods: {
        select() {
         
            this.$emit('select', {
                context: this.componentId
            });
          
            
        }
    }
}
</script>